import React, { useState, useEffect } from "react";
import BaseModal from "components/BaseModal";
import { useSession } from "hooks/useSession";
import { showMainToast } from "utils/showToast";

export default function PlanServiceChargeFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors]         = useState({});
  const [planList, setPlanList]     = useState([]);
  const [serviceList, setServiceList] = useState([]);
  const [editData, setEditData]     = useState(null);
  const { userid } = useSession();

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        // Fetch Plans
        const planForm = new FormData();
        planForm.append("action", "GET");
        planForm.append("userid", userid);
        const planRes  = await fetch("https://pro.mokshiq.in/plan_manager_action", {
          method: "POST",
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
          body: planForm,
        });
        const planData = await planRes.json();
        setPlanList(planData.data || []);

        // Fetch Services
        const svcForm = new FormData();
        svcForm.append("action", "GET");
        svcForm.append("userid", userid);
        const svcRes  = await fetch("https://pro.mokshiq.in/main_service_action", {
          method: "POST",
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
          body: svcForm,
        });
        const svcData = await svcRes.json();
        setServiceList(svcData.data || []);
      } catch (err) { console.error(err); }
    };
    fetchDropdowns();
  }, []);

  useEffect(() => {
    if (mode === "edit" && userData?.id) {
      const fetchById = async () => {
        try {
          const form = new FormData();
          form.append("action", "GETBYID");
          form.append("id", userData.id);
          form.append("userid", userid);
          const res    = await fetch("https://pro.mokshiq.in/plan_service_charge_action", {
            method: "POST",
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            body: form,
          });
          const result = await res.json();
          if (result.status) setEditData(result.data);
        } catch (err) { console.error(err); }
      };
      fetchById();
    } else {
      setEditData(null);
    }
  }, [mode, userData]);

  const validateForm = () => {
    let newErrors = {};
    if (!document.getElementById("plan_id")?.value)    newErrors.plan_id    = "Plan is required.";
    if (!document.getElementById("service_id")?.value) newErrors.service_id = "Service is required.";
    if (!document.getElementById("charge")?.value)     newErrors.charge     = "Charge is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) { showMainToast("Please correct the errors before saving.", "danger"); return; }
    const formData = new FormData();
    formData.append("plan_id",    document.getElementById("plan_id").value);
    formData.append("service_id", document.getElementById("service_id").value);
    formData.append("charge",     document.getElementById("charge").value);
    formData.append("is_active",  document.getElementById("is_active").value);
    formData.append("id",         userData?.id || "");
    formData.append("action",     "ADDUpdate");
    formData.append("userid",     userid);
    try {
      const response = await fetch("https://pro.mokshiq.in/plan_service_charge_action", {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        body: formData,
      });
      const result = await response.json();
      if (result.status) { showMainToast(result.data || "Success!", "success"); onClose(); if (onSuccess) onSuccess(); }
      else showMainToast(result.data || "Something went wrong!", "danger");
    } catch { showMainToast("Something went wrong!", "danger"); }
  };

  const isReady = mode === "add" || (mode === "edit" && editData !== null);

  return (
    <BaseModal
      show={show} onClose={onClose}
      title={mode === "edit" ? "Edit Service Charge" : "Add Service Charge"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        {!isReady ? <div className="text-center py-4">Loading...</div> : (
          <form key={editData?.id || "new"} className="row g-3 app-form rounded-control">

            {/* Plan */}
            <div className="col-md-6">
              <label className="form-label">Plan</label>
              <select id="plan_id" className={`form-select ${errors.plan_id ? "is-invalid" : ""}`} defaultValue={editData?.plan_id || ""}>
                <option value="">-- Select Plan --</option>
                {planList.map((p) => (
                  <option key={p.id} value={p.id}>{p.Name}</option>
                ))}
              </select>
              {errors.plan_id && <div className="text-danger">{errors.plan_id}</div>}
            </div>

            {/* Service */}
            <div className="col-md-6">
              <label className="form-label">Service</label>
              <select id="service_id" className={`form-select ${errors.service_id ? "is-invalid" : ""}`} defaultValue={editData?.service_id || ""}>
                <option value="">-- Select Service --</option>
                {serviceList.map((s) => (
                  <option key={s.id} value={s.id}>{s.Name}</option>
                ))}
              </select>
              {errors.service_id && <div className="text-danger">{errors.service_id}</div>}
            </div>

            {/* Charge */}
            <div className="col-md-6">
              <label className="form-label">Charge (₹)</label>
              <input id="charge" type="number" className={`form-control ${errors.charge ? "is-invalid" : ""}`} defaultValue={editData?.charge || ""} />
              {errors.charge && <div className="text-danger">{errors.charge}</div>}
            </div>

            {/* Status */}
            <div className="col-md-6">
              <label className="form-label">Status</label>
              <select id="is_active" className="form-select" defaultValue={editData?.is_active !== undefined ? String(editData.is_active) : "true"}>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>

          </form>
        )}
      </div>
    </BaseModal>
  );
}